import React, { useEffect } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Input, Label, Form, FormFeedback } from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { registerUser, apiError, refreshWomsUser } from "../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";

// import images
import profileImg from "../../assets/images/profile-img.png";
import logoImg from "../../assets/images/logo.svg";
import i18n from 'i18next';
import withRouter from "components/Common/withRouter";

const Register = props => {

  //meta title
  document.title = i18n.t("AUTHENTICATION.REGISTER") + " | Worldshoppe - OMS";
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
      firstName: '',
      lastName: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required(i18n.t("VALIDATION.REQUIRED")),
      firstName: Yup.string().required(i18n.t("VALIDATION.REQUIRED")),
      lastName: Yup.string().required(i18n.t("VALIDATION.REQUIRED")),
      password: Yup.string().required(i18n.t("VALIDATION.REQUIRED")),
    }),
    onSubmit: (values) => {
      dispatch(registerUser(values, props.router.navigate));
    }
  });

  const { user, registrationError, loading } = useSelector(state => ({
    user: state.Account.user,
    registrationError: state.Account.registrationError,
    loading: state.Account.loading,
  }));

  useEffect(() => {
    dispatch(apiError(""));
  }, []);

  return (
    <>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">{i18n.t("AUTHENTICATION.FREE_REGISTER")}</h5>
                        <p>{i18n.t("AUTHENTICATION.GET_YOUR_ACCOUNT_NOW")}.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profileImg} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logoImg}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {user && user ? (
                        <Alert color="success">
                          {i18n.t("AUTHENTICATION.REGISTRATION_SUCCESSFUL")}
                        </Alert>
                      ) : null}

                      {registrationError && registrationError ? (
                        <Alert color="danger">{registrationError}</Alert>
                      ) : null}

                      <div className="mb-3">
                        <Label className="form-label">{i18n.t("EMAIL")}</Label>
                        <Input
                          id="email"
                          name="email"
                          className="form-control"
                          placeholder={i18n.t("AUTHENTICATION.ENTER_EMAIL")}
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                      <Row>
                        <Col>
                        <Label className="form-label">{i18n.t("FIRST_NAME")}</Label>
                        <Input
                          name="firstName"
                          type="text"
                          placeholder={i18n.t("AUTHENTICATION.ENTER_FIRST_NAME")}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.firstName || ""}
                          invalid={
                            validation.touched.firstName && validation.errors.firstName ? true : false
                          }
                        />
                        {validation.touched.firstName && validation.errors.firstName ? (
                          <FormFeedback type="invalid">{validation.errors.firstName}</FormFeedback>
                        ) : null}
                        </Col>
                        <Col>
                        <Label className="form-label">{i18n.t("LAST_NAME")}</Label>
                        <Input
                          name="lastName"
                          type="text"
                          placeholder={i18n.t("AUTHENTICATION.ENTER_LAST_NAME")}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.lastName || ""}
                          invalid={
                            validation.touched.lastName && validation.errors.lastName ? true : false
                          }
                        />
                        {validation.touched.lastName && validation.errors.lastName ? (
                          <FormFeedback type="invalid">{validation.errors.lastName}</FormFeedback>
                        ) : null}
                        </Col>
                        </Row>
                        </div>
                        <div className="mb-3">
                        <Label className="form-label">{i18n.t("PASSWORD")}</Label>
                        <Input
                          name="password"
                          type="password"
                          placeholder={i18n.t("AUTHENTICATION.ENTER_PASSWORD")}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password || ""}
                          invalid={
                            validation.touched.password && validation.errors.password ? true : false
                          }
                        />
                        {validation.touched.password && validation.errors.password ? (
                          <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                        ) : null}

                      </div>

                      <div className="mt-4">
                        <button
                          className="btn btn-primary btn-block "
                          type="submit"
                        >
                          {i18n.t("AUTHENTICATION.REGISTER")}
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <p className="mb-0">
                          {i18n.t("AUTHENTICATION.TERMS_OF_USE_AGREEMENT_PART_ONE")}{" "}
                          <Link to="#" className="text-primary">
                          {i18n.t("AUTHENTICATION.TERMS_OF_USE")}
                          </Link>
                          {i18n.t("AUTHENTICATION.TERMS_OF_USE_AGREEMENT_PART_TWO")}
                        </p>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  {i18n.t("AUTHENTICATION.ALREADY_HAVE_AN_ACCOUNT")} ?{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    {" "}
                    {i18n.t("LOGIN")}
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} Worldshoppe. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by Codiz Inc
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default withRouter(Register);
